import { render, staticRenderFns } from "./recruitList.vue?vue&type=template&id=35f20886&scoped=true&"
import script from "./recruitList.vue?vue&type=script&lang=js&"
export * from "./recruitList.vue?vue&type=script&lang=js&"
import style0 from "./recruitList.vue?vue&type=style&index=0&id=35f20886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f20886",
  null
  
)

export default component.exports